import React, { useState } from "react";
import InforgraphicForm from "./InfographicForm";
import CustomModal from "../CustomModal";

const infographicData = {
  title: "Have you tried sensory toys to comfort your neurodivergent child?",
  body: "The holidays are just around the corner and you’re probably on the hunt for a memorable gift for your child. We’ve created a quick introduction on how sensory toys can help stimulate senses and engage your neurodivergent child in a way that they enjoy. Check out our infographic to know more.",
  thumbnail: "/infographics/Thumbnail1.jpg",
  previewImage: "/infographics/Thumbnail1.jpg",
  downloadUrl: "/infographics/infographic1.jpg",
  fileName: "social-spectrum-infographic",
};

const InfographicCard = () => {
  const [downloading, setDownloading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDownload = async () => {
    setShowModal(true);
  };

  // Prevent click inside modal from closing
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className=" bg-gray-50 flex flex-col items-center justify-center py-12 md:py-20 px-4">
      {/* Headline */}
      <h1 className="text-18 md:text-36 text-headingtext font-[800] font-avenir w-full ">
        {infographicData.title}
      </h1>

      {/* Body */}
      <p className="text-paratext text-14 md:text-16 mt-3 lg:w-2/3">
        {infographicData.body}
      </p>

      {/* Thumbnail */}
      {/* <div className="mt-6 md:mt-12 w-full relative flex justify-center max-md:px-4 max-lg:px-8 ">
         <button
        className="py-3 absolute  px-6 md:px-[40px] md:text-16  md:py-[16px] bg-gray-800 opacity-50 text-paratext hover:scale-105  text-14 text-white font-[600] rounded-[32px] mt-6 md:mt-12 transition-all"
      >
        Preview
      </button>
        <img
          src={infographicData.thumbnail}
          alt="Infographic Thumbnail"
          className="min-w-[300px] w-full  max-w-[900px] rounded-lg shadow-lg border border-gray-200 cursor-pointer hover:scale-105 transition-transform"
          onClick={() => setShowPreview(true)}
        />
      </div> */}
      <div className="mt-6 md:mt-12 w-full relative flex justify-center max-md:px-4 max-lg:px-8">

  {/* WRAPPER TO CONTROL HOVER */}
  <div className="relative w-full max-w-[900px] group">

    {/* Thumbnail Image */}
    <img
      src={infographicData.thumbnail}
      alt="Infographic Thumbnail"
      className="w-full rounded-lg shadow-lg border border-gray-200 
                 cursor-pointer transition-transform group-hover:scale-105"
    />

    {/* Preview Button (appears only on hover) */}
    <button
      onClick={(e) => {
        e.stopPropagation();       // prevent triggering image click
        setShowPreview(true);
      }}
      className="
       opacity-0
        absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
        px-4 py-2 sm:py-3 hover:bg-gray-700
        bg-gray-800 group-hover:opacity-50 text-white font-semibold rounded-full
        transition-all duration-300  flex gap-2 items-center
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.458 12C3.732 7.943 7.522 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.478 0-8.268-2.943-9.542-7z"
        />
      </svg>
      Preview
    </button>

  </div>
</div>


      {/* Download Button */}
      <button
        onClick={handleDownload}
        className="py-3 px-6 md:px-[40px] md:text-16  md:py-[16px] bg-[#002DA3] text-14 text-white font-[600] rounded-[32px] mt-6 md:mt-12 transition-all"
      >
        {downloading ? "Downloading..." : "Download"}
      </button>

      {/* Modal Preview */}
      {showPreview && (
        <div
          className=" md:absolute max-md:fixed inset-0 bg-black bg-opacity-70 flex  items-center justify-center z-50"
          onClick={() => setShowPreview(false)} // click outside closes modal
        >
          <div
            className="relative min-w-[300px] w-[95vw] lg:w-[80vw]  max-w-[2000px] mx-4  shadow-2xl"
            onClick={handleModalContentClick} // stop propagation
          >
            <img
              src={infographicData.previewImage}
              alt="Infographic Preview"
              className="w-full"
            />
            {/* Close button */}
            <button
              onClick={() => setShowPreview(false)}
              className="absolute top-4 right-4 text-white bg-gray-800 opacity-50 rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-700 transition-colors"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={"Submit Details to Download"}
        height={true}
      >
        <div className="w-full  ">
          <InforgraphicForm showModal={handleClose} data={infographicData} />
        </div>
      </CustomModal>
    </div>
  );
};

export default InfographicCard;
